import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";

const MissedCallAlert = (props) => (
  <SummaryItem itemKey={"Missed Call Alert: "}>
    {props.module.emailGroup.emailList.map((email, idx) => (
      <SectionItem key={idx} itemKey={"Email Address"}>
        {email.email}
      </SectionItem>
    ))}
  </SummaryItem>
);

export default MissedCallAlert;

MissedCallAlert.propTypes = {
  module: PropTypes.object,
};
